// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.contenido {
  padding: 1rem;
}

.radio-espaciado {
  display: flex;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-detalle-ver-documentos/ver-documento/ver-documento.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;;AACA;EACE,aAAA;EACA,SAAA;AAEF","sourcesContent":["div.contenido {\n  padding: 1rem;\n}\n.radio-espaciado {\n  display: flex;\n  gap: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
